let Hooks = {}

Hooks.Tags = {
    mounted() {
        this.initTagSelector();
    },

    updated() {
        this.ensureDomStructure()
        this.loadInitialTags();
        this.renderTags();
    },

    ensureDomStructure() {
        const parent = this.el.parentElement;

        let hiddenInput = parent.querySelector(`#${this.el.id}-hidden`);
        if (!hiddenInput) {
            hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = this.el.name;
            hiddenInput.id = `${this.el.id}-hidden`;
            parent.appendChild(hiddenInput);
            this.el.removeAttribute("name");
        }

        let tagContainer = parent.querySelector('#selected-tags');
        if (!tagContainer) {
            tagContainer = document.createElement('div');
            tagContainer.id = 'selected-tags';
            tagContainer.className = 'tags margin-top';
            parent.appendChild(tagContainer);

            tagContainer.addEventListener('click', e => {
                const tagEl = e.target.closest('.label');
                if (tagEl) {
                    const tag = tagEl.getAttribute('data-tag');
                    this.selectedTags.delete(tag);
                    this.renderTags();
                }
            });
        }

        this.hiddenInput = hiddenInput;
        this.tagContainer = tagContainer;
    },


    initTagSelector() {
        this.ensureDomStructure();

        this.masterTags = new Set(
            Array.from(this.el.options)
                .filter(opt => !opt.disabled && opt.value)
                .map(opt => opt.value)
        );

        this.selectedTags = new Set();

        this.loadInitialTags();
        this.renderTags();

        this.el.addEventListener('change', () => {
            const tag = this.el.value;
            if (!this.selectedTags.has(tag) && this.masterTags.has(tag)) {
                this.selectedTags.add(tag);
                this.renderTags();
            }
            this.el.selectedIndex = 0;
        });
    },

    loadInitialTags() {
        const selected = (this.el.dataset.selected || "")
            .split(",")
            .map(t => t.trim())
            .filter(t => t);

        this.selectedTags = new Set(selected);
    },

    updateHiddenInput() {
        this.hiddenInput.value = Array.from(this.selectedTags).join(",");
    },

    renderTags() {
        this.tagContainer.innerHTML = '';
        this.selectedTags.forEach(tag => {
            const tagEl = document.createElement('span');
            tagEl.className = 'label forward pointer';
            tagEl.textContent = tag;
            tagEl.setAttribute('data-tag', tag);
            this.tagContainer.appendChild(tagEl);
        });
        this.updateHiddenInput();
    }
}

export {Hooks}